module.exports = __webpack_public_path__ + "img/js_logo.430c8790.jpg";